var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getComponentForField(_vm.field.type),{tag:"component",attrs:{"field":_vm.field,"formData":_vm.formData,"showLabel":_vm.showLabel}})}
var staticRenderFns = []

export { render, staticRenderFns }